module.exports = __webpack_public_path__ + "static/pastwork-046dda949554d36c0d6b6d718ab60728.png";